import { computed, ref, Ref, watch } from "vue";
import { GenericField } from "@/business/shared/commons/validator/validatorsTypes";
import { RequiredRule } from "@/business/shared/commons/validator/rules/RequiredRule";
import { NumericRule } from "@/business/shared/commons/validator/rules/NumericRule";
import { validator } from "@/business/shared/commons/validator/validator";

export function createEditEventValidator() {
  const name: Ref<GenericField> = ref({
    enabled: false,
    errors: [],
    isSuccess: true,
    val: "",
    rules: [new RequiredRule("El mombre es obligatorio")],
  });
  const date: Ref<GenericField> = ref({
    enabled: false,
    errors: [],
    isSuccess: true,
    val: "",
    rules: [new RequiredRule("La fecha máxima de registro es obligatoria")],
  });
  const guests: Ref<GenericField> = ref({
    enabled: false,
    errors: [],
    isSuccess: true,
    val: "",
    rules: [new RequiredRule("El máximo de invitados por cliente es obligatorio"), new NumericRule("El máximo de invitados por cliente debe ser numérico")],
  });

  watch(
    () => name.value.val,
    () => {
      if ((name.value.val?.length ?? 0) > 0) {
        name.value.enabled = true;
      }
    }
  );
  watch(
    () => date.value.val,
    () => {
      if ((date.value.val?.length ?? 0) > 0) {
        date.value.enabled = true;
      }
    }
  );
  watch(
    () => guests.value.val,
    () => {
      if ((guests.value.val?.length ?? 0) > 0) {
        guests.value.enabled = true;
      }
    }
  );

  function validate(field: GenericField, otherValue?: string): GenericField {
    return validator().validateField(field, otherValue);
  }

  const successForm = computed(() => {
    name.value = validate(name.value);
    date.value = validate(date.value);
    guests.value = validate(guests.value);


    return !(
      name.value.isSuccess &&
      date.value.isSuccess &&
      guests.value.isSuccess
    );
  });

  const successFormEdit = computed(() => {
    name.value = validate(name.value);
    date.value = validate(date.value);
    guests.value = validate(guests.value);


    return !(
      name.value.isSuccess &&
      date.value.isSuccess &&
      guests.value.isSuccess
    );
  });

  function reset(): void {
    name.value.val = "";
    date.value.val = "";
    guests.value.val = "";
    name.value.enabled = false;
    date.value.enabled = false;
    guests.value.enabled = false;
  }

  return {
    name,
    date,
    guests,
    successForm,
    successFormEdit,
    reset,
  };
}
